import { useIntl } from "react-intl";

import { LoggedOutBlueWaveTemplateJsm } from "../components";

export const LoggedOutJsmPremium = () => {
    const { formatMessage } = useIntl();
    return (
        <LoggedOutBlueWaveTemplateJsm
            productEditionText={formatMessage({
                id: "WacSignupHeader.cloudPremium",
                defaultMessage: "Cloud Premium"
            })}
        />
    );
};
